import type { PageThemeDefinition } from "../types";

/** GG PANALO — 主色 #182D01 */
export const ggTheme: PageThemeDefinition = {
  id: "gg",
  labelKey: "robot.setting.page_theme.gg",
  preview: {
    background: "#0F1800",
    cardBg: "#182D01",
    text: "#ffffff",
  },
  tokens: {
    background: "#0F1800",
    cardBg: "#182D01",
    text: "#ffffff",
    textSecondary: "#A8C890",
    border: "#2A4A10",
    headerBg: "#0F1800",
    inputBg: "#182D01",
    messageBg: "#182D01",
    senderBg: "#182D01",
    statusOnline: "#02BA54",
    statusEnding: "#ED645F",
    starActive: "#FFE200",
    starInactive: "#3A5028",
    shadow: "rgba(0, 0, 0, 0.5)",
    hoverBg: "#1F3804",
    accent: "#6EDC3D",
    appearance: "dark",
    chatMessageText: "#FFFFFF",
    chatAgentBubbleBg: "#1F3804",
    chatAgentBubbleBorder: "#2A4A10",
    chatUserGradientStart: "#4CD137",
    chatUserGradientEnd: "#182D01",
    chatUserMessageText: "#FFFFFF",
    chatInputFieldBg: "#0F1800",
    chatInputText: "#FFFFFF",
    chatInputPlaceholder: "#A8C890",
    chatMediaBg: "#0F1800",
    chatIconColor: "#FFFFFF",
    chatLinkColor: "#00C8FF",
  },
};
